import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
} from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatDialog, MatDialogConfig } from "@angular/material";
import { MatPaginator } from "@angular/material/paginator";
import { LOAN_SETTLEMENT_NEGOTIATION_STATUS, LoanSettlementNegotiation, SettledLoansDetails } from "../../model/rbi-compliance/loan-settlement-negotiation.model";
import { LoanSettlementNegotiationService } from "../../service/rbi-compliance/loan-settlement-negotiation.service";
import { Toaster, Type } from "../../toaster/Toaster";
import { LoanSettlementNegotiationAcceptPopUpComponent } from "../loan-settlement-negotiation-accept-pop-up/loan-settlement-negotiation-accept-pop-up.component";
import { LoanSettlementNegotiationRejectPopUpComponent } from "../loan-settlement-negotiation-reject-pop-up/loan-settlement-negotiation-reject-pop-up.component";
import { LoanSettlementNegotiationPopUpComponent } from "../loan-settlement-negotiation-pop-up/loan-settlement-negotiation-pop-up.component";

@Component({
  selector: 'app-loan-settlement-table',
  templateUrl: './loan-settlement-table.component.html',
  styleUrls: ['./loan-settlement-table.component.css']
})
export class LoanSettlementTableComponent
  implements OnInit, AfterViewInit {
  @Input() loanSettlementNegotiation: LoanSettlementNegotiation;
  @Output() rowClick = new EventEmitter<any>();
  dataSource: SettledLoansDetails[];

  displayedColumns: string[] = [
    "generatedLoanId",
    "investedAmount",
    "grossCashFlowReceivedBeforeSettlement",
    "principalOutstandingBeforeSettlement",
    "settlementAmountOffered",
    "grossCashFlowReceivedPostSettlement",
    "settlementNegotiationStatus",
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  data: any;
  itemsPerPage = 5;
  visibleData: any[] = [];
  sortColumn: string = "";
  sortDirection: string = "asc";
  tableData: SettledLoansDetails[] = [];

  constructor(
    public dialog: MatDialog,
    private readonly loanSettlementNegotiationService: LoanSettlementNegotiationService,
    private changeDetectorRefs: ChangeDetectorRef
  ) { }

  sortData(column: string): void {
    if (this.sortColumn === column) {
      // If the same column is clicked, reverse the sorting direction
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else {
      // If a new column is clicked, set it as the sorting column and default to ascending
      this.sortColumn = column;
      this.sortDirection = "asc";
    }
    // Sort the visibleData array
    this.visibleData = this.sortArray(this.visibleData);
  }

  private sortArray(data: any[]): any[] {
    const isAsc = this.sortDirection === "asc";
    return data.sort((a, b) => {
      if (a[this.sortColumn] < b[this.sortColumn]) {
        return isAsc ? -1 : 1;
      } else if (a[this.sortColumn] > b[this.sortColumn]) {
        return isAsc ? 1 : -1;
      } else {
        return 0;
      }
    });
  }

  ngOnInit() {
    this.tableData = this.loanSettlementNegotiation.settledLoansDetails;
    this.dataSource = this.tableData;
  }

  ngAfterViewInit(): void {
    this.paginator.length = this.tableData.length;
    this.paginator.pageSize = this.itemsPerPage;
    this.onPageChange({
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
    });
  }

  onPageChange(event: any): void {
    const startIndex = event.pageIndex * event.pageSize;
    const endIndex = startIndex + event.pageSize;
    this.paginator.pageIndex = event.pageIndex;
    //use start index and end index for fetching data
    this.visibleData = this.tableData.slice(startIndex, endIndex);
  }

  actionButtonHandler(status: LOAN_SETTLEMENT_NEGOTIATION_STATUS, data: SettledLoansDetails): void {
    console.log(`STATUS :  [${status}] AND DATA : [${JSON.stringify(data)}]`);
    const lenderId: string = this.loanSettlementNegotiation.lenderId;
    if (status === LOAN_SETTLEMENT_NEGOTIATION_STATUS.ACCEPTED) {
      this.dialog.open(LoanSettlementNegotiationAcceptPopUpComponent, {width: '32vw', panelClass: 'loan-settlement-accepted-dialog'}).afterClosed().subscribe((res) => {
        if (res) {
          this.updateLoanSettlementNegotiation(lenderId, { ...data, settlementNegotiationStatus: status })
        }
      });
    } else if(status === LOAN_SETTLEMENT_NEGOTIATION_STATUS.REJECTED) {
      this.dialog.open(LoanSettlementNegotiationRejectPopUpComponent, {width: '32vw', panelClass: 'loan-settlement-reject-dialog'}).afterClosed().subscribe((res) => {
        if (res) {
          this.updateLoanSettlementNegotiation(lenderId, { ...data, settlementNegotiationStatus: status })
        }
      });
    } else {
      const matDialogConfig: MatDialogConfig = {
        width: '50%',
        panelClass: 'confirm-dialog-responsive',
        data: {
          principalOutstandingBeforeSettlement: data.principalOutstandingBeforeSettlement,
          settlementAmountOffered: data.settlementAmountOffered
        }
      };
      this.dialog.open(LoanSettlementNegotiationPopUpComponent, matDialogConfig).afterClosed().subscribe((res) => {
        if (res) {
          console.log('RESPONSE ', res)
          this.updateLoanSettlementNegotiation(lenderId, { ...data, settlementNegotiationStatus: status, settlementAmountDemanded: res.settlementAmountDemanded })
        }
      });
    }
  }

  public async updateLoanSettlementNegotiation(id: string, data: SettledLoansDetails) {
    this.loanSettlementNegotiationService.updateLoanSettlementNegotiation(id, data)
      .then((res) => {
        Toaster.toast('Updated Loan Terms Suggestion', Type.Success);
        this.tableData = res.settledLoansDetails;
        this.dataSource = this.tableData.slice();;
        this.changeDetectorRefs.detectChanges();
      })
      .catch((err) => {
        console.log("ERROR : ", err)
      })
  }

  public get loanSettlementNegotiationStatus(): typeof LOAN_SETTLEMENT_NEGOTIATION_STATUS {
    return LOAN_SETTLEMENT_NEGOTIATION_STATUS;
  }
}
